import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { DoService } from '../../services/do-service/do.service';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FluidModule } from 'primeng/fluid';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DividerModule } from 'primeng/divider';
import { ConfirmationService, MessageService } from 'primeng/api';
import { NgIf } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-gestion-do',
  imports: [
    InputTextModule,
    FluidModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbModule,
    DividerModule,
    NgIf,
    ConfirmDialogModule,
    ToastModule,
    MessageModule
  ],
  templateUrl: './gestion-do.component.html',
  styleUrl: './gestion-do.component.scss',
  providers: [MessageService, ConfirmationService]

})
export class GestionDoComponent {

  breadcrumbHome = { icon: 'pi pi-home', RouterLink: '/rechercher-do' };
  breadcrumbItems = [{ label: 'Gestion DO' }];

  doDetails: any = {};
  doForm!: FormGroup;
  do: any;
  nomDo!: string;
  
  constructor(
    private router: Router,
    private doService: DoService,
    private fb: FormBuilder,
    private messageService: MessageService,
      private confirmationService: ConfirmationService,
  ) {
    const savedDo = sessionStorage.getItem('selectedDo');
    if (!savedDo) {
      this.router.navigate(['/rechercher-do']);
    } else {
      const doData = JSON.parse(savedDo);
      this.do = doData.code_interne;
      this.nomDo = doData.Nom;
      this.loadDoDetails(doData.code_interne); 
    }
    this.initForm();
  }

  initForm(): void {
    this.doForm = this.fb.group({
      code_interne: [{ value: '', disabled: true }],
      Identifiant: [{ value: '', disabled: true }],
      Nom: [{ value: '', disabled: true}],
      Activite: [''],
      MultiLangue: [''],
      MissionPA: [''],
      Site1Nom: [''],
      Site1Adresse: [''],
      Site1Ville: [''],
      Site1CP: [''],
      Site1Pays: [''],
      Site1Telephone: [''],
      Site1Fax: [''],
      Site1PlanAcces: [''],
      Site2Nom: [''],
      Site2Adresse: [''],
      Site2Ville: [''],
      Site2CP: [''],
      Site2Pays: [''],
      Site2PlanAcces: [''],
      Site3Nom: [''],
      Site3Adresse: [''],
      Site3Ville: [''],
      Site3CP: [''],
      Site3Pays: [''],
      Site3Telephone: [''],
      Site3Fax: [''],
      Site3PlanAcces: [''],
      AdrEmailGenerale: ['', Validators.email],
      SiteWeb: ['']
    });
  }

 loadDoDetails(codeInterne: number): void {
    this.doService.getDoById(codeInterne).subscribe({
      next: (data: any) => {
        this.doDetails = data;
        if (data && data.length > 0) {
          this.doForm.patchValue(data[0]);
        }
      },
      error: (error) => {
        console.error('Error fetching DO details:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Impossible de charger les détails du DO'
        });
      }
    });
  }
 onSubmit(): void {
    if (this.doForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Veuillez corriger les erreurs dans le formulaire'
      });
      return;
    }

    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir enregistrer les modifications?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      rejectButtonStyleClass : 'p-button-secondary',
      accept: () => {
        this.saveChanges();
      }
    });
  }

  private saveChanges(): void {
    const formValue = ({
      ...this.doForm.value,
      code_interne: this.doForm.get('code_interne')?.value,
      Identifiant: this.doForm.get('Identifiant')?.value,
      Nom: this.doForm.get('Nom')?.value
    });

    this.doService.updateDoByCI(formValue.code_interne, formValue).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: 'DO - '+ formValue.code_interne + ' est mis à jour avec succès'
        });
        this.doForm.markAsPristine();
      },
      error: (error) => {
        console.error('Error updating DO:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Échec de la mise à jour du DO'
        });
      }
    });
  }

  onCancel(): void {
    if (this.doForm.dirty) {
      this.confirmationService.confirm({
        message: 'Voulez-vous vraiment annuler? Les modifications non enregistrées seront perdues.',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Oui',
        rejectLabel: 'Non',
        accept: () => {
          this.router.navigate(['/rechercher-do']);
        }
      });
    } else {
      this.router.navigate(['/rechercher-do']);
    }
  }
}